// ABOUTME: User profile icon showing avatar inside circle
// ABOUTME: Supports className, size, and color customization

interface IconProps {
  className?: string
  size?: number
  color?: string
  strokeColor?: string
}

export const UserProfileIcon = ({ className = "", size = 14, color = "#000", strokeColor = "#F2F2F2" }: IconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 14 14"
    fill="none"
    className={className}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13 7C13 7.78793 12.8448 8.56815 12.5433 9.2961C12.3066 9.86755 11.9833 10.398 11.5858 10.8692C11.4769 10.9983 11.3624 11.1229 11.2426 11.2426C10.6855 11.7998 10.0241 12.2417 9.2961 12.5433C8.56815 12.8448 7.78793 13 7 13C6.21207 13 5.43185 12.8448 4.7039 12.5433C3.97595 12.2417 3.31451 11.7998 2.75736 11.2426C2.63758 11.1229 2.52312 10.9983 2.41423 10.8692C2.01666 10.398 1.69342 9.86755 1.45672 9.2961C1.15519 8.56815 1 7.78793 1 7C1 5.4087 1.63214 3.88258 2.75736 2.75736C3.88258 1.63214 5.4087 1 7 1C8.5913 1 10.1174 1.63214 11.2426 2.75736C12.3679 3.88258 13 5.4087 13 7Z"
      fill={color}
    />
    <path
      d="M2.414 10.8693C3.81294 10.0786 5.39305 9.66423 7 9.66667C8.66667 9.66667 10.2313 10.1033 11.586 10.8693M9 5.66667C9 6.1971 8.78929 6.70581 8.41421 7.08088C8.03914 7.45595 7.53043 7.66667 7 7.66667C6.46957 7.66667 5.96086 7.45595 5.58579 7.08088C5.21071 6.70581 5 6.1971 5 5.66667C5 5.13623 5.21071 4.62753 5.58579 4.25245C5.96086 3.87738 6.46957 3.66667 7 3.66667C7.53043 3.66667 8.03914 3.87738 8.41421 4.25245C8.78929 4.62753 9 5.13623 9 5.66667ZM13 7C13 7.78793 12.8448 8.56815 12.5433 9.2961C12.2417 10.0241 11.7998 10.6855 11.2426 11.2426C10.6855 11.7998 10.0241 12.2417 9.2961 12.5433C8.56815 12.8448 7.78793 13 7 13C6.21207 13 5.43185 12.8448 4.7039 12.5433C3.97595 12.2417 3.31451 11.7998 2.75736 11.2426C2.20021 10.6855 1.75825 10.0241 1.45672 9.2961C1.15519 8.56815 1 7.78793 1 7C1 5.4087 1.63214 3.88258 2.75736 2.75736C3.88258 1.63214 5.4087 1 7 1C8.5913 1 10.1174 1.63214 11.2426 2.75736C12.3679 3.88258 13 5.4087 13 7Z"
      stroke={strokeColor}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
